// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchAddressForm_wrapper__WKRUo"};